import React from "react";
import { useAppState } from "../screens/App/shared/AppState/app-state";
import { ApolloClient, ApolloProvider, HttpLink, InMemoryCache, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import configuration from '../screens/App/shared/configuration';
import { connect } from "react-redux";

const httpLink = new HttpLink({
  uri: configuration.AccmanApiUrl + "graphql/",
});

// Apollo GraphQL client for Accman service API
// TODO: Replace with a generic Apollo client for all API calls for Federated GraphQL
const ApolloProviderWrapper = (props) => {

  const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = props.token;
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      }
    }
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: from([
      authLink,
      httpLink
    ]),
  });

  return (
    <ApolloProvider client={client}>
      <div>
        {props.children}
      </div>
    </ApolloProvider>
  );
}
const mapStateToProps = (state) => ({
  token: state.appState.getIn(['serverData', 'shared', 'token']),
});

export default connect(mapStateToProps)(ApolloProviderWrapper);